<div class="mt-4">
    <div class="welcome-screen container-sm mt-5 pt-5">
        <div class="justify-content-center">
            <div class="card shadow-lg p-5 text-center">
                <div class="modal-content">
                    <div class="modal-header">
                        <h4 class="modal-title title">
                            <i class="far fa-check-circle"></i> {{"LABEL.IDENTITY-VERIFICATION" | translate}}</h4>
                    </div>
                </div>
                <div [innerHTML]="messageInfo"></div>

                <div class="error-box" *ngIf="messageErrorRequest !==''">
                    <i class="fas fa-exclamation-circle fa-2x text-danger"></i>
                    <strong class="text-danger fz-19">{{messageErrorRequest}}</strong>
                    <p class="font-weight-normal text-danger" *ngIf="showMessageInfo">
                        {{"MESSAGE.SEND-CODE-VERIFICATION-PHONE-NUMBER-WHATSAPP" | translate}}
                    </p>
                </div>

                <div *ngIf="requestMessage !==''"
                     class="alert alert-success mt-2  {{requestMessage !== '' ? 'fade-in' : 'fade-out'}}"
                     role="alert">
                    <i class="fa fa-exclamation-circle fa-2x text-success"></i>
                    <div [innerHTML]="requestMessage | translate">
                    </div>
                </div>

                <form [formGroup]="signatureForm">
                    <a class="disabled1">{{"MESSAGE.CODE-LASTS-3-MINUTES" | translate}}</a>
                    <input type="text" placeholder="{{ 'MESSAGE.ENTER-CODE' | translate }}..."
                           formControlName="codeOTP"
                           [maxLength]="6"
                           class="form-control w-100">
                    <small *ngIf="isInvalidControl('codeOTP')" class="text-danger">
                        {{ "MESSAGE.ENTER-CODE-6-DIGIT" | translate }}
                    </small>
                </form>

                <button id="btnSendOTP" class="btn btn-link text-primary" [disabled]="isEnable4sendOTP">
                    <span *ngIf="isEnable4sendOTP">
                        {{"BUTTON.RESEND-CODE" | translate}} en {{secondLeft}}s
                    </span>
                    <span *ngIf="!isEnable4sendOTP" (click)="generateOTP(false)">
                          {{"MESSAGE.RESEND-CODE-6-DIGITS" | translate}}
                    </span>
                </button>

                <div class="card-footer">
                    <div class="buttons">
                        <button class="btn btn-secondary" (click)="goBack()">
                            <i class="fa fa-reply"></i> {{ "BUTTON.BACK" | translate}}
                        </button>
                        &nbsp;
                        <button class="submit btn btn-success"
                                (click)="signCloud()">
                            <i class="fas fa-signature"></i> {{"BUTTON.SIGN" | translate}}
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
<app-loading *ngIf="loading"></app-loading>
